import { haveSharedMembers } from '../../lib/array.no-deps'
import { assumeExhaustion } from '../../lib/typeHelpers.no-deps'
import type { UnitWorkflowParameter } from '../UnitWorkflowParameter/types.no-deps'
import type { TFullUnit } from '../units/types.no-deps'
import type { WorkflowParameter } from '../workflowParameter/types.no-deps'
import type { Unit, UnitFilter } from './UnitFilter.no-deps'
import { apply as applyJsonLogic } from 'json-logic-js'

export function applyUnitFiltering(
    unitTypeId: number,
    workflowParameters: WorkflowParameter[],
    scheduleParameters: UnitWorkflowParameter[],
    filters: UnitFilter[],
    reportSubject: Pick<TFullUnit, 'id'> | undefined,
    unit: Unit,
    opts: {
        /** In pessimistic mode, when ambiguous filters are present, we filter out */
        pessimistic?: boolean
    }
) {
    if (unit.type !== unitTypeId) return false
    if (unit.isDeleted) return false
    for (const filter of filters) {
        if (filter.type === 'ParentInList') {
            if (!haveSharedMembers(unit.parents, filter.unitIds)) return false
            continue
        }
        if (filter.type === 'ParentIsSubject') {
            if (opts.pessimistic && reportSubject == null) return false
            if (!unit.parents.includes(reportSubject.id)) return false
            continue
        }
        if (filter.type === 'UnitAttributes') {
            if (!applyJsonLogic(filter.value, unit.data)) return false
            continue
        }
        if (filter.type === 'ParentIsUserSelectable') {
            if (opts.pessimistic) return false

            // we don't know what the user is going to choose at this point so
            // we will do the filtering later on in the process
            continue
        }
        if (filter.type === 'ParentFromParameter') {
            const parameterId = filter.parameterId
            const parameter = workflowParameters.find((p) => p.id === parameterId)
            if (!parameter) {
                continue
            }
            if (parameter.referenceType !== 'unit-type' || parameter.referenceId !== filter.unitType) {
                throw new Error(
                    `Parameter with id ${parameterId} is not a parameter for unit type with id ${filter.unitType}`
                )
            }
            const unitIdFromParameter = scheduleParameters.find((p) => p.workflowParameter === parameterId)?.unit
            if (!unitIdFromParameter) {
                continue
            }
            if (!unit.parents.includes(unitIdFromParameter)) return false

            continue
        }
        assumeExhaustion(filter)
    }
    return true
}
